import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getMeetingRoomMasterListUrl, insertUpdateMeetingRoomMasterUrl, deleteMeetingRoomMasterUrl, GET_MEETING_ROOM_MASTER_LIST, DELETE_MEETING_ROOM_MASTER, INSERT_UPDATE_MEETING_ROOM_MASTER, verifyMeetingRoomComboSlotUrl, VERIFY_MEETING_ROOM_COMBO_SLOT } from "../../../../utils/constants";


export const insertUpdateMeetinRoomMaster_action = (MstMeetingRoomID, Date, RoomTypeID, SeatingCapacity, FromTime, ToTime, Location, RateInINR, RateInUSD, comboSlotList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MstMeetingRoomID: MstMeetingRoomID,
            Date: Date,
            RoomTypeID: RoomTypeID,
            RoomTypeID: RoomTypeID,
            SeatingCapacity: SeatingCapacity,
            FromTime: FromTime,
            ToTime: ToTime,
            Location: Location,
            RateInINR: RateInINR,
            RateInUSD: RateInUSD,
            comboSlotList: comboSlotList,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateMeetingRoomMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_MEETING_ROOM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getMeetinRoomMasterList_action = (MstMeetingRoomID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MstMeetingRoomID: MstMeetingRoomID
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getMeetingRoomMasterListUrl, params, headers)

        dispatch({
            type: GET_MEETING_ROOM_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteMeetinRoomMaster_action = (MstMeetingRoomID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MstMeetingRoomID: MstMeetingRoomID
        }

        const res = await axiosGet(deleteMeetingRoomMasterUrl, params, headers)

        dispatch({
            type: DELETE_MEETING_ROOM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const verifyMeetingRoomComboSlot_action = (SeatingCapacity, Date, RoomTypeID, Location) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            SeatingCapacity: SeatingCapacity,
            Date: Date,
            RoomTypeID: RoomTypeID,
            Location: Location,
        }

        const res = await axiosGet(verifyMeetingRoomComboSlotUrl, params, headers)

        dispatch({
            type: VERIFY_MEETING_ROOM_COMBO_SLOT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}